// MaintenancePage v0.1.0 — full-screen takeover when state.maintenance.enabled
// is true. Backend polling continues so SSE will push the toggle-off event
// the moment an admin disables maintenance, swapping the UI back without a
// page refresh.
import type { MaintenanceBlock } from '../lib/api.js';
import CommandPanel from './ui/CommandPanel.js';
import SectionHeader from './ui/SectionHeader.js';

interface Props {
  maintenance: MaintenanceBlock;
}

export default function MaintenancePage({ maintenance }: Props) {
  return (
    <div className="min-h-screen bg-bg text-text flex items-center justify-center px-4 font-mono">
      <CommandPanel className="w-full max-w-xl border border-warn/60" bodyClassName="space-y-0">
        <SectionHeader
          title="MAINTENANCE"
          right={
            <span className="text-warn" aria-hidden="true">
              OFFLINE
            </span>
          }
        />
        <div className="p-4 space-y-6 text-center">
          <div className="text-warn text-6xl" aria-hidden="true">
            🛠
          </div>
          <h1 className="text-2xl tracking-[3px] text-white font-semibold">UNDER MAINTENANCE</h1>
          <p className="text-muted leading-relaxed">
            The dashboard is temporarily offline for maintenance. Provider monitoring continues in
            the background — we&apos;ll be back shortly.
          </p>
          {maintenance.message && (
            <p className="text-text border border-border bg-surface2 p-4 text-sm">
              {maintenance.message}
            </p>
          )}
          {maintenance.started_at && (
            <p className="text-dim text-xs">
              Started: {new Date(maintenance.started_at).toLocaleString()}
            </p>
          )}
          <footer className="pt-8 text-[11px] text-dim tracking-wide">
            © {new Date().getFullYear()} AvenisLabs ·{' '}
            <a href="mailto:info@avenislabs.com" className="text-accent hover:underline">
              info@avenislabs.com
            </a>
          </footer>
        </div>
      </CommandPanel>
    </div>
  );
}
